'use client';

import dynamic from 'next/dynamic';
import Link from 'next/link';

import { Button } from '@kit/ui/button';
import { If } from '@kit/ui/if';
import { Trans } from '@kit/ui/trans';

import featuresFlagConfig from '~/config/feature-flags.config';
import pathsConfig from '~/config/paths.config';

import { useSession } from '../_hooks/use-session';

const ModeToggle = dynamic(
  () =>
    import('@kit/ui/mode-toggle').then((mod) => ({
      default: mod.ModeToggle,
    })),
  { ssr: false },
);

const MobileModeToggle = dynamic(
  () =>
    import('@kit/ui/mobile-mode-toggle').then((mod) => ({
      default: mod.MobileModeToggle,
    })),
  { ssr: false },
);

const features = {
  enableThemeToggle: featuresFlagConfig.enableThemeToggle,
};

function ThemeToggleSection() {
  return (
    <>
      <div className={'hidden md:flex'}>
        <If condition={features.enableThemeToggle}>
          <ModeToggle />
        </If>
      </div>

      <div className={'md:hidden'}>
        <If condition={features.enableThemeToggle}>
          <MobileModeToggle />
        </If>
      </div>
    </>
  );
}

export function SiteHeaderAccountSection() {
  const session = useSession();

  if (session.isPending) {
    return null;
  }

  if (session.data) {
    return (
      <div
        className={'animate-in fade-in flex items-center gap-x-2 duration-500'}
      >
        <ThemeToggleSection />

        <Button
          asChild
          className="text-xs md:text-sm"
          variant={'default'}
          size={'sm'}
        >
          <Link href={pathsConfig.app.chat} data-testid="open-chat-button">
            <Trans i18nKey={'marketing:openChat'} />
          </Link>
        </Button>
      </div>
    );
  }

  return <AuthButtons />;
}

function AuthButtons() {
  return (
    <div
      className={'animate-in fade-in flex items-center gap-x-2 duration-500'}
    >
      <ThemeToggleSection />

      <div className={'flex items-center gap-x-2'}>
        <Button
          className={'hidden md:flex md:text-sm'}
          asChild
          variant={'outline'}
          size={'sm'}
        >
          <Link
            href={pathsConfig.auth.signIn}
            data-testid="auth-sign-in-button"
          >
            <Trans i18nKey={'auth:signIn'} />
          </Link>
        </Button>

        <Button
          asChild
          className="text-xs md:text-sm"
          variant={'default'}
          size={'sm'}
        >
          <Link
            href={pathsConfig.auth.signUp}
            data-testid="auth-sign-up-button"
          >
            <Trans i18nKey={'auth:signUp'} />
          </Link>
        </Button>
      </div>
    </div>
  );
}
